import { AdminShiftsListLoading } from '@/views/admin-shifts/home/admin-shifts-list.loading';

export default AdminShiftsListLoading;
